import { StyleSheet } from 'react-native';
import { COLORS } from '../../../config/colors';
import { verticalSize, height } from '../../../functions/responsive';
import { THEME_COLORS } from '../../../theme/constants/themeColors';
import { THEME_STYLES } from '../../../theme/constants/themeStyles';

export default StyleSheet.create({
  root: {
    backgroundColor: THEME_COLORS.bgColor,
    justifyContent: 'space-between',
    height: height(100)
  },
  mainCont: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  batteryPerCont: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    marginTop: 48
  },
  whiteBlockCont: {
    // borderWidth: 1,
    // borderBottomWidth: 3,
    // borderColor: THEME_COLORS.borderColor,
    padding: 12,
    borderRadius: 16,
    minHeight: 75,
    justifyContent: 'space-between',
    flex: 1,
    ...THEME_STYLES.themeBorder,
    borderWidth: 0,
    borderBottomWidth: 0,
    backgroundColor: THEME_COLORS.bgSecondary,
  },
  rowStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  divider: {
    height: 1,
    backgroundColor: '#ffffff60',
    marginVertical: 16
  },
  bottomCont: {
    backgroundColor: COLORS.darkBlack,
    padding: 16
  },
  stopBtn: {
    backgroundColor: COLORS.brightRed,
    borderRadius: THEME_STYLES.buttonStyle.borderRadius,
    paddingVertical: 15,
    paddingHorizontal: 12,
    justifyContent: 'center',
    alignItems: 'center'
  }
});
